import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "../lib/api";

export default function ForgotPassword() {
    const [email, setEmail] = useState("");
    const [done, setDone] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError("");
        try {
            await api.post("/auth/forgot-password", { email });
            setDone(true);
            toast.success("Check your email for a reset link");
        } catch (err) {
            const status = err.response?.status;
            const detail = err.response?.data?.detail;
            const msg = formatApiErrorDetail(detail);
            if (status === 429 || /rate.?limit/i.test(msg)) {
                setError("Too many requests from your network. Wait a few minutes (or switch to mobile data) and try again.");
            } else if (err.message === "Network Error") {
                setError("Couldn't reach the server. Check your internet and try again.");
            } else {
                setError(msg || "Could not send reset");
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Helmet><title>Forgot password — OpenCSV</title></Helmet>
            <section className="min-h-[70vh] flex items-center">
                <div className="mx-auto max-w-md w-full px-4 md:px-8 py-16">
                    <div className="ui-heading text-xs uppercase tracking-widest text-ink-muted mb-3">/ recovery</div>
                    <h1 className="font-display font-black tracking-tighter text-4xl mb-6">Forgot your password?</h1>
                    {done ? (
                        <p className="text-sm text-ink-soft" data-testid="forgot-success">If an account exists for {email}, a reset link has been sent. Check your inbox.</p>
                    ) : (
                        <form onSubmit={submit} className="space-y-3" data-testid="forgot-form">
                            <div>
                                <label className="ui-heading text-xs uppercase tracking-widest text-ink-soft">Email</label>
                                <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1 w-full border border-ink/20 px-3 py-2.5 bg-white focus-cobalt" data-testid="forgot-email-input" />
                            </div>
                            {error && <div className="text-sm text-signal-red">{error}</div>}
                            <button type="submit" disabled={loading} className="btn-brutal w-full bg-ink text-white px-4 py-3 ui-heading font-semibold disabled:opacity-60" data-testid="forgot-submit-button">
                                {loading ? "Sending…" : "Send reset link"}
                            </button>
                            <p className="text-sm text-ink-soft mt-2">
                                Remembered it? <Link to="/login" className="text-cobalt hover:underline">Sign in</Link>
                            </p>
                        </form>
                    )}
                </div>
            </section>
        </>
    );
}
